import { create } from 'zustand';
import { FacilityAddData, FacilityListItem, FacilityUpdateData } from '@libs/models/facilities';
import { activateFacility, addFacility, updateFacility } from '@libs/api/facilities/actions';
import { fetchFacilityDetails } from '@libs/api/facilities';

type InitialState = {
  loading: boolean;
  currentEntityId: string;
  entity: FacilityListItem | null;
  drawerOpen: boolean;
  drawerMode: 'add' | 'edit' | 'view';

  load: (id: string) => Promise<void>;
  addFacility: (data: FacilityAddData) => Promise<void>;
  addActivateFacility: (data: FacilityAddData) => Promise<void>;
  updateFacility: (id: string, data: FacilityUpdateData) => Promise<void>;
  openDrawer: (id?: string, mode?: InitialState['drawerMode']) => void;
  closeDrawer: () => void;
};

export const useFacilityEditStore = create<InitialState>()((set) => ({
  loading: false,
  currentEntityId: '',
  entity: null,
  drawerMode: 'add',
  drawerOpen: false,

  load: async (id) => {
    set({ loading: true });
    try {
      const resp = await fetchFacilityDetails(id);
      set({
        loading: false,
        entity: resp,
      });
    } finally {
      set({ loading: false });
    }
  },
  addFacility: async (data: FacilityAddData) => {
    const id = await addFacility(data);
  },
  addActivateFacility: async (data: FacilityAddData) => {
    const id = await addFacility(data);
    await activateFacility(id);
  },
  updateFacility: async (id: string, data: FacilityUpdateData) => {
    const resp = await updateFacility(id, data);
  },
  openDrawer: (id?: string, mode?: InitialState['drawerMode']) =>
    set({ drawerOpen: true, drawerMode: mode ? mode : id ? 'edit' : 'add', currentEntityId: id ?? '' }),
  closeDrawer: () => set({ drawerOpen: false }),
}));
